import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useResource from './useResource';

export default function useHouseholdResource(initial, args) {
  const householdContext = useSimpleHousehold();

  const { setHouseholdState } = householdContext;
  const { resource, setAttribute, setResourceDeprecated } = useResource(initial, args);

  function saveToContext() {
    return setHouseholdState(resource.export());
  }

  return {
    resource,
    setAttribute,
    setResourceDeprecated,
    saveToContext, // To context
  };
}
